import React from "react";
import { useUser } from "@clerk/nextjs";
import TextInput from "components/formComponents/TextInput/TextInput";
import EmailInput from "components/formComponents/EmailInput/EmailInput";
import TextArea from "components/formComponents/TextArea/TextArea";
import PhoneInput from "components/formComponents/PhoneInput/PhoneInput";

import styles from "./CheckoutForm.module.scss";
import formStyles from "components/forms/formStyles.module.scss";

export default function CheckoutForm({
  pageName,
  register,
  formState,
  isSubmitting,
  success,
  useFormMethods,
}) {
  const { isSignedIn, isLoaded, user } = useUser();

  const firstNameDefault = isSignedIn && isLoaded ? user?.firstName : null;
  const lastNameDefault = isSignedIn && isLoaded ? user?.lastName : null;

  return (
    <>
      <fieldset className={`${formStyles.rowFieldset}`}>
        <TextInput
          id="firstname"
          label="First name"
          defaultValue={firstNameDefault}
          register={register}
          formState={formState}
          attributes={{ disabled: isSubmitting }}
          useFormMethods={useFormMethods}
          wrapperProps={{ width: "half", required: true }}
        />

        <TextInput
          id="lastname"
          label="Last name"
          defaultValue={lastNameDefault}
          register={register}
          formState={formState}
          attributes={{ disabled: isSubmitting }}
          useFormMethods={useFormMethods}
          wrapperProps={{ width: "half", required: true }}
        />
      </fieldset>
      <PhoneInput
        id="phone"
        label="Phone"
        register={register}
        formState={formState}
        attributes={{ disabled: isSubmitting }}
        useFormMethods={useFormMethods}
      />
      <EmailInput
        id="email"
        label="Email"
        attributes={{ disabled: isSubmitting }}
        register={register}
        formState={formState}
        useFormMethods={useFormMethods}
        wrapperProps={{ required: true }}
      />

      <TextArea
        id="message"
        label="Message"
        attributes={{ rows: 20, disabled: isSubmitting }}
        register={register}
        formState={formState}
        wrapperProps={{
          instructions:
            "Please feel free to send any questions, special considerations, or additional information you may have.",
        }}
      />
    </>
  );
}
